import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./reducers/rootReducer";
import { config } from "./services/config";
import thunk from "redux-thunk";


// Redux DevTools
const composeEnhancers =
  (config.buildEnv === "DEV"
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : null) || compose;

export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);
